<template>
  <div v-if="phase.active" :class="['bonus_phase', (phase.type === 'CROSS_PROMOTION') ? 'promo_phase_fp' : '' ]" :id="[ (phase.type === 'CROSS_PROMOTION' && showOptOutPhase) ? 'optout' : 'bonus_phase_' + index ]">
    <div class="bonus_phase_inner" @click.prevent="nextModal">
      <div :class="[(phase.type === 'CROSS_PROMOTION' && !showOptOutPhase) ? 'bonus_phase_icon' : '', (phase.type === 'CROSS_PROMOTION' && !showOptOutPhase) ? 'promo_phase_fp' : '' ]">
        <img v-if="phase.type === 'PLAY_WITH_CELEB'" src="static/images/celebrity.svg" alt="">
        <img v-else-if="phase.type === 'BUNDLES'" src="static/images/bonus_phase_discount.svg" alt="">
        <img v-else-if="phase.type === 'CROSS_PROMOTION' && !showOptOutPhase" :src="getTranslations.home_bonus_phase_cross_promote_img" alt="">
        <img v-else-if="!showOptOutPhase" src="static/images/bonus_points.svg" alt="">
      </div>
      <div v-if="phase.type === 'CROSS_PROMOTION' && !showOptOutPhase" class="promo_phase_outer">
        <div class="bonus_phase_content promo_phase_fp">
          <h1>{{ getTranslations.home_bonus_phase_cross_promote_header }}</h1>
          <p>{{ getTranslations.home_bonus_phase_cross_promote_desc }}</p>
        </div>
        <div class="promo_phase_btn" v-if="getTranslations.home_bonus_phase_cross_promote_redirection_url">
          <div class="challenge_btn" >
            <a v-if="true" @click.prevent="goToRedirectUrl" class="btn2 btn--v2 btn2--medium btn2--fp">
              {{ getTranslations.home_bonus_phase_cross_promote_button }}</a>
          </div>
        </div>
      </div>
      <div v-else-if="phase.type === 'CROSS_PROMOTION' && showOptOutPhase" class="promo_phase_outer">
            <div class="promo_phase_outer">
              <div class="bonus_phase_content promo_phase_fp">
                <p> {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_message') }} <a class="optout__link" @click.prevent="goToEditProfile">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_click_here') }}</a></p>
              </div>
            </div>
          <button class="bonusclose"  id="bonusclose"></button>
      </div>
      <div v-else class="bonus_phase_content">
        <h1 v-if="phase.type === 'PLAY_WITH_CELEB'">{{ getTranslations.home_bonus_phase_celebrity_header }}</h1>
        <h1 v-else-if="phase.type === 'BUNDLES'">{{ getTranslations.home_bonus_phase_discount_bonus_header }}</h1>
        <h1 v-else>{{ getTranslations.home_bonus_phase_multiplier_bonus_header }}</h1>
        <p v-if="phase.type === 'PLAY_WITH_CELEB'">{{ getTranslations.home_bonus_phase_celebrity_desc }}</p>
        <p v-else-if="phase.type === 'BUNDLES'">{{ getTranslations.home_bonus_phase_discount_bonus_desc }}</p>
        <p v-else>{{ getTranslations.home_bonus_phase_multiplier_bonus_desc }}</p>
      </div>
      <div v-if="phase.type !== 'CROSS_PROMOTION'" class="bonus_phase_timer">
        <h1>{{ counter }}</h1>
      </div>
    </div>
    <button class="bonusclose" :id="['bonusclose' + index]" @click.prevent="phase.active = false"></button>
  </div>
</template>

<script>
// type BUNDLES (lsc)= discount
// type POINTS (lsc) = multiplier
import { mapState, mapGetters, mapMutations } from 'vuex';
import Vue from 'vue';
import PointsMultiplier from './modals/bonus_phases/PointsMultiplier';
import BundleDiscount from './modals/bonus_phases/BundleDiscount';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'bonus-phase',
  props: {
    phase: Object,
    index: Number,
  },
  data() {
    return {
      timer: 0,
      counter: 0,
    };
  },
  created() {
    if (this.phase.type !== 'CROSS_PROMOTION') this.initiateCountDownTimer(); // CROSS PROMOTION PHASE DOES NOT HAVE COUNTDOWN TIMER
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'updatePhaseBonusModalToBeDisplayed',
    ]),
    goToRedirectUrl() {
      window.location.href = `${this.getTranslations.home_bonus_phase_cross_promote_redirection_url}?refUrl=crossPromotion_${window.location.hostname}`;
    },
    goToEditProfile() {
      this.$router.push({ name: 'edit' });
    },
    initiateCountDownTimer() {
      const interval = 1000; // every 1 second
      let duration;
      // get time element
      // calculate difference between two times
      const eventTime = moment(this.phase.end);
      // loop to countdown every 1 second
      this.timer = setInterval(() => {
        // based on time set in user's computer time / OS
        const currentTime = moment(new Date());
        // get duration between two times
        duration = moment.duration(eventTime.diff(currentTime));
        // get updated duration
        duration = moment.duration(duration - interval, 'milliseconds');

        // if duration is >= 0
        if (currentTime.isAfter(eventTime)) {
          clearInterval(this.timer);
          // hide the countdown element
          this.counter = '';
          this.phase.active = false;
        } else {
          // otherwise, show the updated countdown
          this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
        }
      }, interval);
    },
    nextModal() {
      if (['PLAY_WITH_CELEB', 'CROSS_PROMOTION'].includes(this.phase.type)) return;
      let modal;
      switch (this.phase.type) {
      case 'POINTS':
        modal = PointsMultiplier;
        break;
      case 'BUNDLES':
        modal = BundleDiscount;
        break;
      default:
        modal = null;
        break;
      }
      this.updatePhaseBonusModalToBeDisplayed(this.phase);
      this.storeModalForHomePage(modal);
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'showOptOutPhase',
      'showCrossPromotionPhase',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getTranslationByOperatorIfExists',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/BonusPhase.vue